/* eslint-disable @typescript-eslint/default-param-last */
import { ReduxAction } from '..';
import {
  GET_TRIP_LIST,
  GET_TRIP_DETAILS,
  POST_TRIP_TYPE,
  POST_TRIP_STOPS,
  POST_TRIP_BOOKING,
  UPDATE_SELECTED_TRIP_DATA,
  PUT_TRIP_CANCEL,
  POST_TRIP_UPDATE_CLUSTERING,
  SET_TOKEN,
} from '../constants';
import { ReducerState } from './_prototype';

const initialState: ReducerState = {
  token: '',
  tripList: null,
  tripListState: '',
  tripListError: null,

  tripData: null,
  tripDataState: '',
  tripDataError: null,

  tripType: null,
  tripTypeState: '',
  tripTypeError: null,

  tripStops: null,
  tripStopsState: '',
  tripStopsError: null,

  tripBooking: null,
  tripBookingState: '',
  tripBookingError: null,

  selectedTripTypeData: null,

  tripCancel: null,
  tripCancelState: '',
  tripCancelError: null,

  tripUpdateClustering: null,
  tripUpdateClusteringState: '',
  tripUpdateClusteringError: null,
};

export default function actionReducer(
  state = initialState,
  action: ReduxAction
) {
  switch (action.type) {
    case `${SET_TOKEN}`:
      return {
        ...state,
        token: action.payload,
      };
    case `${GET_TRIP_LIST}_PENDING`:
      return {
        ...state,
        tripList: null,
        tripListState: 'loading',
        tripListError: null,
      };
    case `${GET_TRIP_LIST}_FULFILLED`:
      return {
        ...state,
        tripList: action.payload,
        tripListState: 'success',
        tripListError: null,
      };
    case `${GET_TRIP_LIST}_REJECTED`:
      return {
        ...state,
        tripList: null,
        tripListState: 'error',
        tripListError: action.payload,
      };
    case `${GET_TRIP_LIST}_RESET`:
      return {
        ...state,
        tripList: null,
        tripListState: '',
        tripListError: null,
      };
    case `${GET_TRIP_DETAILS}_PENDING`:
      return {
        ...state,
        tripData: null,
        tripDataState: 'loading',
        tripDataError: null,
      };
    case `${GET_TRIP_DETAILS}_FULFILLED`:
      return {
        ...state,
        tripData: action.payload,
        tripDataState: 'success',
        tripDataError: null,
      };
    case `${GET_TRIP_DETAILS}_REJECTED`:
      return {
        ...state,
        tripData: null,
        tripDataState: 'error',
        tripDataError: action.payload,
      };
    case `${GET_TRIP_DETAILS}_RESET`:
      return {
        ...state,
        tripData: null,
        tripDataState: '',
        tripDataError: null,
      };

    case `${POST_TRIP_TYPE}_PENDING`:
      return {
        ...state,
        tripType: null,
        tripTypeState: 'loading',
        tripTypeError: null,
      };
    case `${POST_TRIP_TYPE}_FULFILLED`:
      return {
        ...state,
        tripType: action.payload,
        tripTypeState: 'success',
        tripTypeError: null,
      };
    case `${POST_TRIP_TYPE}_REJECTED`:
      return {
        ...state,
        tripType: null,
        tripTypeState: 'error',
        tripTypeError: action.payload,
      };
    case `${POST_TRIP_TYPE}_RESET`:
      return {
        ...state,
        tripType: null,
        tripTypeState: '',
        tripTypeError: null,
      };

    case `${POST_TRIP_STOPS}_PENDING`:
      return {
        ...state,
        tripStops: null,
        tripStopsState: 'loading',
        tripStopsError: null,
      };
    case `${POST_TRIP_STOPS}_FULFILLED`:
      return {
        ...state,
        tripStops: action.payload,
        tripStopsState: 'success',
        tripStopsError: null,
      };
    case `${POST_TRIP_STOPS}_REJECTED`:
      return {
        ...state,
        tripStops: null,
        tripStopsState: 'error',
        tripStopsError: action.payload,
      };
    case `${POST_TRIP_STOPS}_RESET`:
      return {
        ...state,
        tripStops: null,
        tripStopsState: '',
        tripStopsError: null,
      };

    case `${POST_TRIP_BOOKING}_PENDING`:
      return {
        ...state,
        tripBooking: null,
        tripBookingState: 'loading',
        tripBookingError: null,
      };
    case `${POST_TRIP_BOOKING}_FULFILLED`:
      return {
        ...state,
        tripBooking: action.payload,
        tripBookingState: 'success',
        tripBookingError: null,
      };
    case `${POST_TRIP_BOOKING}_REJECTED`:
      return {
        ...state,
        tripBooking: null,
        tripBookingState: 'error',
        tripBookingError: action.payload,
      };
    case `${POST_TRIP_BOOKING}_RESET`:
      return {
        ...state,
        tripBooking: null,
        tripBookingState: '',
        tripBookingError: null,
      };

    case `${UPDATE_SELECTED_TRIP_DATA}`:
      return {
        ...state,
        selectedTripTypeData: action.payload,
      };
    case `${UPDATE_SELECTED_TRIP_DATA}_RESET`:
      return {
        ...state,
        selectedTripTypeData: null,
      };

    case `${PUT_TRIP_CANCEL}_PENDING`:
      return {
        ...state,
        tripCancel: null,
        tripCancelState: 'loading',
        tripCancelError: null,
      };
    case `${PUT_TRIP_CANCEL}_FULFILLED`:
      return {
        ...state,
        tripCancel: action.payload,
        tripCancelState: 'success',
        tripCancelError: null,
      };
    case `${PUT_TRIP_CANCEL}_REJECTED`:
      return {
        ...state,
        tripCancel: null,
        tripCancelState: 'error',
        tripCancelError: action.payload,
      };
    case `${PUT_TRIP_CANCEL}_RESET`:
      return {
        ...state,
        tripCancel: null,
        tripCancelState: '',
        tripCancelError: null,
      };
    case `${POST_TRIP_UPDATE_CLUSTERING}_PENDING`:
      return {
        ...state,
        tripUpdateClustering: null,
        tripUpdateClusteringState: 'loading',
        tripUpdateClusteringError: null,
      };
    case `${POST_TRIP_UPDATE_CLUSTERING}_FULFILLED`:
      return {
        ...state,
        tripUpdateClustering: action.payload,
        tripUpdateClusteringState: 'success',
        tripUpdateClusteringError: null,
      };
    case `${POST_TRIP_UPDATE_CLUSTERING}_REJECTED`:
      return {
        ...state,
        tripUpdateClustering: null,
        tripUpdateClusteringState: 'error',
        tripUpdateClusteringError: action.payload,
      };
    case `${POST_TRIP_UPDATE_CLUSTERING}_RESET`:
      return {
        ...state,
        tripUpdateClustering: null,
        tripUpdateClusteringState: '',
        tripUpdateClusteringError: null,
      };

    default:
      return state;
  }
}
